import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Initialize Meta Pixel
if (typeof window !== 'undefined') {
  ;
  (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  (window as any).fbq('init', '1389266472663692');
  (window as any).fbq('track', 'PageView');
  (window as any).fbq('track', 'ViewContent');
}
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-1">
    <App data-id="element-2" />
  </React.StrictMode>);